import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { CustomAlertEdit } from './CustomAlertEdit';

storiesOf('Manage Alerts/CustomAlerts', module)
  .add('Edit Alert', () => (
    <CustomAlertEdit
      show
      alert={customAlert}
      onClose={() => null}
      onSave={action('updateCustomAlert')}
    />
  )).add('Edit Alert invalid', () => (
    <CustomAlertEdit
      show
      alert={invalidAlert}
      onClose={() => null}
      onSave={action('updateCustomAlert')}
    />
  )).add('Edit Alert with all interval options ', () => (
    <CustomAlertEdit
      show
      alert={customAlertWithAllIntervalOptions}
      onClose={() => null}
      onSave={action('updateCustomAlert')}
    />
  ))
  .add('Edit Alert with limited interval options ', () => (
    <CustomAlertEdit
      show
      alert={customAlertWithLimitedIntervalOptions}
      onClose={() => null}
      onSave={action('updateCustomAlert')}
    />
  ));

const invalidAlert = {
  id: 206,
  name: '',
  created: 1532043435,
  last_execute: 1540123200,
  type: 'General',
  notify_interval: 300,
  delivery: '0',
  mail_list: ['qwe'],
  delivery_options: ['', 'rss', 'webhook'],
  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
};

const customAlert = {
  id: 206,
  name: 'motion - docket',
  created: 1532043435,
  last_execute: 1540123200,
  type: 'General',
  notify_interval: 3600,
  notify_interval_options: [
    { value: -1, label: 'Save/Pause' },
    { value: 3600, label: 'Hourly' },
    { value: 86400, label: 'Daily' },
    { value: 604800, label: 'Weekly' },
  ],
  delivery: '',
  delivery_options: [
    { value: '', label: 'Email' },
    { value: 'rss', label: 'RSS' },
    { value: 'webhook', label: 'Webhook' },
  ],
  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
};

const customAlertWithAllIntervalOptions = {
  id: 206,
  name: 'motion - docket',
  created: 1532043435,
  last_execute: 1540123200,
  type: 'General',
  notify_interval: 3600,
  notify_interval_options: [
    { value: -1, label: 'Save/Pause' },
    { value: 3600, label: 'Hourly' },
    { value: 86400, label: 'Daily' },
    { value: 604800, label: 'Weekly' },
  ],
  delivery: '',
  delivery_options: [
    { value: '', label: 'Email' },
    { value: 'rss', label: 'RSS' },
    { value: 'webhook', label: 'Webhook' },
  ],
  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
};

const customAlertWithLimitedIntervalOptions = {
  id: 206,
  name: 'motion - docket',
  created: 1532043435,
  last_execute: 1540123200,
  type: 'General',
  notify_interval: 3600,
  notify_interval_options: [
    { value: -1, label: 'Save/Pause' },
    { value: 3600, label: 'Hourly' },
  ],
  delivery: '',
  delivery_options: [
    { value: '', label: 'Email' },
    { value: 'rss', label: 'RSS' },
  ],
  list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
};



// WEBPACK FOOTER //
// ./src/components/searchAlerts/CustomAlerts/CustomAlertEdit.stories.jsx